import {
  AddBudgetFormModalContextProvider,
  AddIncidentExpenseFormModalContextProvider,
  AddIncidentReportFormModalContextProvider,
  AddPicturesFromIncidentFormModalContextProvider,
  AddSupplierFormModalContextProvider,
  IncidentReportDetailModalContextProvider,
  ShowGalleryPictureModalContextProvider,
  UpdateStatusWithNoteModalContextProvider,
} from '@/contexts'
import {
  BudgetDetailList,
  IncidentDetailExpensesList,
  IncidentDetailNotesList,
  IncidentDetailOverview,
  IncidentDetailReportsList,
} from '../organism'

type IncidentDetailTemplateProps = {
  selectedSection: string;
  openChat?: boolean;
}

export const IncidentDetailTemplate = ({ selectedSection, openChat = false }: IncidentDetailTemplateProps) => {
  return (
    <>
      {
        (
          () => {
            switch (selectedSection) {
              case '1':
                return (
                  <AddSupplierFormModalContextProvider>
                    <UpdateStatusWithNoteModalContextProvider>
                      <ShowGalleryPictureModalContextProvider>
                        <AddPicturesFromIncidentFormModalContextProvider>
                          <IncidentDetailOverview openChat={openChat} />
                        </AddPicturesFromIncidentFormModalContextProvider>
                      </ShowGalleryPictureModalContextProvider>
                    </UpdateStatusWithNoteModalContextProvider>
                  </AddSupplierFormModalContextProvider>
                )

              case '2':
                return <IncidentDetailNotesList />

              case '3':
                return (
                  <AddBudgetFormModalContextProvider>
                    <BudgetDetailList />
                  </AddBudgetFormModalContextProvider>
                )
              
              case '4':
                return (
                  <AddIncidentReportFormModalContextProvider>
                    <IncidentReportDetailModalContextProvider>
                      <ShowGalleryPictureModalContextProvider>
                        <IncidentDetailReportsList />
                      </ShowGalleryPictureModalContextProvider>
                    </IncidentReportDetailModalContextProvider>
                  </AddIncidentReportFormModalContextProvider>
                )

              case '5':
                return (
                  <AddIncidentExpenseFormModalContextProvider>
                    <IncidentDetailExpensesList />
                  </AddIncidentExpenseFormModalContextProvider>
                )

              default:
                console.warn('invalid option')
                throw new Error('invalid option')
            }
          }
        )()
      }
    </>
  )
}